<template>
  <div>
    <h2>Lets verify your will...</h2>
    <p>Upload your signed will to let us verify it for you.</p>
    <div>
      <span class="verification-status-left">Verification status:</span>
      <span class="verification-status-right">{{
        latestVersionStatusDetails.status
      }}</span>
      <v-progress-linear
        value="100"
        :color="latestVersionStatusDetails.color"
        height="5"
        background-color="grey"
      />
    </div>
    <div class="mt-6">
      <span class="verification-status-left">Will location:</span>
      <span class="verification-status-right">
        {{ determineWillLocation }}
      </span>
      <v-progress-linear
        value="100"
        color="secondary"
        height="5"
        background-color="grey"
      />
    </div>
    <div class="mt-6">
      <span class="verification-status-left">Will Collection:</span>
      <span class="verification-status-right">
        {{ willBookingDetails }}
      </span>
      <v-progress-linear
        value="100"
        color="var(--v-tertiary-base)"
        height="5"
        background-color="grey"
      />
    </div>

    <div class="mt-6 will-verification-container">
      <GradientButton
        @gradientButtonClicked="willVerification()"
        title="Verify Will"
        :small="true"
        :fill="buttonFill"
        :callout="'right'"
      />
      <GradientButton
        @gradientButtonClicked="willLocation()"
        title="Set Will Location"
        :small="true"
        :fill="buttonFill"
        :callout="'right'"
      />
      <GradientButton
        v-if="determineWillBooking"
        @gradientButtonClicked="bookCollection()"
        title="Book Collection"
        :small="true"
        :fill="true"
        :callout="'right'"
      />
    </div>
  </div>
</template>

<script>
  import {
    verificationStatus,
    latestWillVersion,
  } from '../../constants/js/will-verification';
  export default {
    name: 'OverviewWillVerification',
    data() {
      return {
        willCollectionBooking: null,
      };
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
      willDetailsChanged: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      willVerification() {
        this.$router.push({ name: 'WillVerification' });
      },
      willLocation() {
        this.$router.push({ name: 'WillLocation' });
      },
      bookCollection() {
        this.$router.push({
          name: 'WillCollectionBooking',
          query: { testatorId: this.testator.id },
        });
      },
    },
    computed: {
      latestVersion() {
        return latestWillVersion(this.testator.willVersions);
      },
      latestVersionStatusDetails() {
        return verificationStatus(this.latestVersion.status, this.icons);
      },
      determineWillLocation() {
        if (!!this.testator.dateStored) {
          return 'Old Mutual Wills Vault';
        }
        if (!this.testator.willLocation) {
          return 'Location not set';
        }
        return this.testator.willLocation.length > 22
          ? this.testator.willLocation.substring(0, 22) + '...'
          : this.testator.willLocation;
      },
      buttonFill() {
        return this.willDetailsChanged;
      },
      determineWillBooking() {
        if (!this.testator?.email?.includes(this.whitelabel.shippingUserCode)) {
          return false;
        }

        if (this.collectionCancelled) {
          return true;
        }

        return (
          this.determineWillValidity &&
          !this.testator.willCollectionBooked &&
          !this.activeWillCollectionBooking
        );
      },
      determineWillValidity() {
        return latestWillVersion(this.testator.willVersions).status === 'VALID';
      },
      activeWillCollectionBooking() {
        return this.testator.activeWillCollectionBooking || null;
      },
      collectionCancelled() {
        // Use latestWillCollectionBooking (the most recent booking regardless of
        // status) rather than activeWillCollectionBooking. A booking is only
        // "active" while its collection date is in the future, so a cancelled
        // (or past-dated) booking has activeWillCollectionBooking === null and the
        // cancellation could never be detected — leaving the user unable to
        // re-schedule after a cancellation.
        if (!this.testator.latestWillCollectionBooking) {
          return false;
        }

        return (
          this.testator.latestWillCollectionBooking.collectionStatus ===
            'cancelled' &&
          (this.testator.latestWillCollectionBooking.willVersionId ===
            this.latestVersion.id ||
            this.determineWillValidity)
        );
      },
      willBookingDetails() {
        if (!this.testator.activeWillCollectionBooking) {
          return '';
        }

        const booking = this.testator.activeWillCollectionBooking;

        if (booking.statusDisplayName === 'Cancelled') {
          return 'Cancelled';
        }

        return booking.collectionDetails || '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .verification-status-right {
    float: right;
    font-size: 16px;
    font-weight: bold;
  }

  .verification-status-left {
    font-size: 18px;
    font-weight: bold;
  }

  @media screen and (max-width: 350px) {
    .verification-status-right {
      font-size: 14px;
    }

    .verification-status-left {
      font-size: 16px;
    }
  }

  .verify-my-will-btn {
    float: left;
  }

  .set-will-location-btn {
    float: right;
  }

  .clear {
    clear: both;
  }

  .will-verification-container {
    display: flex;
    gap: 26px;
  }

  @media only screen and (min-width: 0px) and (max-width: 430px) {
    .will-verification-container {
      flex-direction: column;
    }
  }
</style>
